import React, { useState } from "react";
import { CashierImagePreview } from "./CashierImagePreview";
import "./CashierStyle.css";

export interface CashierPreviewImageProps {
  src: string;
  alt?: string;
  className?: string;
  previewAriaLabel?: string;
}

export const CashierPreviewImage: React.FC<CashierPreviewImageProps> = ({
  src,
  alt = "",
  className,
  previewAriaLabel = "查看大图",
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="cashier-preview-image-btn"
        aria-label={previewAriaLabel}
        onClick={() => setOpen(true)}
      >
        <img src={src} alt={alt} className={className} />
      </button>
      <CashierImagePreview
        src={src}
        alt={alt}
        open={open}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
